module.exports = __webpack_public_path__ + "img/slider2.f425da2e.jpg";